import React from 'react'
import { CategoryTitle, Text } from 'components'
import styles from './Pendencies.module.scss'

const Pendencies = ({ pendencies }) => {
  if (!pendencies) {
    return null
  }

  return (
    <section>
      <CategoryTitle icon="about" title="Pendência(s) Existente(s)" />
      <Text fontSize="medium" className={styles.darkColor}>
        {pendencies}
      </Text>
    </section>
  )
}

export default Pendencies
